import { Box } from '@dtx-company/design-system/src'
import { FC, ReactNode } from 'react'

export const PrintStoreContainer: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        paddingLeft: 0,
        width: '100%',
        display: 'block',
        height: '100%'
      }}
    >
      {children}
    </Box>
  )
}
